module.exports = __webpack_public_path__ + "img/h-6.7aa275ef.png";